<template>
  <navbar position="fixed" type="white" menu-classes="ml-auto">
    <template slot-scope="{ toggle, isToggled }">
      <router-link v-popover:popover class="navbar-brand" to="/presentation">
        doodhvale.com
      </router-link>
      <el-popover ref="popover" popper-class="popover" placement="bottom" width="200" trigger="hover">
        <div class="popover-body">
          &copy; {{ year }}, by doodhvale.com | All rights reserved | Sanjeevani Dairy Farms Private Limited
        </div>
      </el-popover>
    </template>
    <template slot="navbar-menu">
      <drop-down tag="li" title="Sample Dropdown">
        <nav-link class="dropdown-item">
          <i class="now-ui-icons shopping_box"></i> Headers
        </nav-link>
      </drop-down>
    </template>
  </navbar>
</template>

<script>
import { DropDown, NavbarToggleButton, Navbar, NavLink } from '@/components';
import { Popover } from 'element-ui';

export default {
  name: 'main-navbar',
  components: {
    DropDown,
    Navbar,
    NavbarToggleButton,
    NavLink,
    [Popover.name]: Popover
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>

<style scoped>

</style>
